import React, { Component } from "react";
import "./App.css";
import ListItmes from "./ListItems";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

library.add(faTrash);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      currentItem: {
        text: "",
        key: "",
      },
    };
    this.formHandler = this.formHandler.bind(this);
    this.inputHandler = this.inputHandler.bind(this);
  }

  inputHandler = (e) => {
    this.setState({
      currentItem: {
        text: e.target.value,
        key: Date.now(),
      },
    });
  };

  formHandler = (e) => {
    e.preventDefault();
    const NewItem = this.state.currentItem;
    if (NewItem.text !== "") {
      const newItems = [...this.state.items, NewItem];
      console.log(newItems);
      this.setState({
        items: newItems,
        currentItem: {
          text: "",
          key: "",
        },
      });
    }
  };

  deleteTaskHandler = (key) => {
    const updatedItems = this.state.items.filter((item) => item.key !== key);
    this.setState({items:updatedItems})
  };

  editTaskHandler= (e,key) => {
    let items = this.state.items;
    
   items.map(item=>{

      if(item.key===key){
        item.text=e.target.value;
        return true;
      }
      return false;
    })

    this.setState({items:items});
    
  };

  render() {
    return (
      <div className="App">
        <header>
          <form id="todo-form" onSubmit={this.formHandler}>
            <input
              type="text"
              onChange={this.inputHandler}
              placeholder="Enter Text"
              value={this.state.currentItem.text}
            ></input>
            <button type="submit">Add</button>
          </form>
        </header>
        <ListItmes
          items={this.state.items}
          deleteClicked={this.deleteTaskHandler}
          editTask={this.editTaskHandler}
        ></ListItmes>
      </div>
    );
  }
}

export default App;
